import React from 'react';
import ModalSuperUserValidation from '../components/Liquidation/LiquidationTreeView/ModalSuperUserValidation';

interface UseModalSuperUserValidationData {
	isValidated: boolean;
	validationComponent: React.ReactNode;
}

const useModalSuperUserValidation = (): UseModalSuperUserValidationData => {
	const [isValidated, setIsValidated] = React.useState<boolean>(false);

	const handleChange = React.useCallback((data: boolean) => {
		setIsValidated(data);
	}, []);

	const validationComponent = (
		<ModalSuperUserValidation onChange={handleChange} />
	);

	return {
		isValidated,
		validationComponent,
	};
};
export default useModalSuperUserValidation;
